module.exports = __webpack_public_path__ + "img/pin.02ee34db.svg";